// https://switcheroo.atlassian.com/ui/gates/f0c8695a-3334-4f50-99e2-cecd6570ea6d/key/atlassian_projects_-_native_integration
export const PROJECTS_NATIVE_INTEGRATION_WITH_JIRA = 'atlassian_projects_-_native_integration';

// Verified teams in for you experiment - exposure only fires when recommendedTeams query has results
export const VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT = 'verified_teams_in_for_you';

// Teams recommendations for you experiment - exposure only fires when rovo teams recommendations are cached.
export const TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT = 'recommended_teams_in_for_you_page';

// https://switcheroo.atlassian.com/ui/gates/5df9f216-7f3c-4f54-a2c7-67873439d0ac/key/jira-space-invite-teams-app
export const JIRA_SPACE_INVITE_TEAMS_APP = 'jira-space-invite-teams-app';

// UC ML Powered Relevancy Engine experiment - https://switcheroo.atlassian.com/ui/gates/a8938eb8-f50c-457e-b185-35ed81e19657/key/navx_uc_ml_powered_relevancy_engine
export const NAVX_UC_ML_POWERED_RELEVANCY_ENGINE = 'navx_uc_ml_powered_relevancy_engine';

// Gates the Rovo Insights carousel on Atlas Home (and the chat side-nav pulse touchpoint).
// https://switcheroo.atlassian.com/ui/gates/d53e8811-df0a-4bdf-a5bb-bc7ffa76bb0f/key/rovo_growth_chat_pulse
export const ROVO_GROWTH_CHAT_PULSE_EXPERIMENT = 'rovo_growth_chat_pulse';

// https://switcheroo.atlassian.com/ui/gates/73ac0d28-4145-4453-a140-608117641c58/key/rovo_home_input_intent_exp
export const ROVO_HOME_INPUT_INTENT_EXP = 'rovo_home_input_intent_exp';

export const ROVO_TOWNSQ_EMPTY_STATE_GET_PROJECT_DETAILS_SKILL =
	'rovo_townsq_empty_state_get_project_details_skill';

export const HOME_ONBOARDING_TO_ROVO_CHAT_AND_SEARCH = 'home_onboarding_to_rovo_chat_and_search';

//https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/townsquare_enable_discover_preview_panels_exp/setup
export const DISCOVER_PREVIEW_PANELS_EXPERIMENT = 'townsquare_enable_discover_preview_panels_exp';

// https://switcheroo.atlassian.com/ui/gates/3a164ac5-c960-42dc-9e1b-0617ec400141/key/townsquare_enable_rovo_home_appification_exp
export const TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP =
	'townsquare_enable_rovo_home_appification_exp';

/** @internal Used for testing the router's featureGating experiment support only */
export const ROUTER_TEST_EXPERIMENT = 'townsquare_router_test_experiment';

// https://switcheroo.atlassian.com/ui/gates/614213e6-cf9f-4cf4-9abe-c3d53a1b2af8/key/home_calendar_widget
export const HOME_CALENDAR_WIDGET_EXPERIMENT = 'home_calendar_widget';

// https://switcheroo.atlassian.com/ui/gates/5ffdf699-274b-484b-bfa7-1bfa7cab84fb/key/townsquare_assigned_pr_chat_integration
export const TOWNSQUARE_ASSIGNED_PR_CHAT_INTEGRATION_EXP =
	'townsquare_assigned_pr_chat_integration';

// https://switcheroo.atlassian.com/ui/gates/59be6817-f494-4620-a8fb-592d4d8ac030/key/rovo_conversation_sharing
export const ROVO_CONVERSATION_SHARING_EXP = 'rovo_conversation_sharing';

export const ROVO_CHAT_SPACES_EXPERIMENT = 'rovo_chat_spaces_experiment';

export const TOWNSQUARE_ASSIGNED_LIST_EXP = 'townsquare_assigned_list';

export const ROVO_CHAT_MENTION_AGENTS_EXPERIMENT = 'rovo_chat_mention_agents';

// Gates rendering emojis through the platform unicode emoji path.
// https://switcheroo.atlassian.com/ui/gates/c50c5255-4c35-4dc6-8833-b7cd201e977b/key/platform_use_unicode_emojis
export const PLATFORM_USE_UNICODE_EMOJIS = 'platform_use_unicode_emojis';

// Controls refreshed emoji picker behavior in Teamwork surfaces.
// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_teamoji_26_refresh_emoji_picker/setup
export const PLATFORM_TEAMOJI_26_REFRESH_EMOJI_PICKER = 'platform_teamoji_26_refresh_emoji_picker';

export const TOWNSQUARE_VIEWED_DEFAULT_TAB = 'townsquare_exp_viewed_as_default';

export const ATLAS_GOAL_TYPES_M3_BUNDLED_UPDATES = 'atlas_goal_types_m3_bundled_updates';

export const USER_PROFILE_CARD_MIGRATION_EXP = 'pt_user_profile_card_migration_exp';

// Make sure you add your experiment to the list of valid experiments
export const experiments: {
	readonly ROUTER_TEST_EXPERIMENT: 'townsquare_router_test_experiment';
	readonly PROJECTS_NATIVE_INTEGRATION_WITH_JIRA: 'atlassian_projects_-_native_integration';
	readonly VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT: 'verified_teams_in_for_you';
	readonly TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT: 'recommended_teams_in_for_you_page';
	readonly JIRA_SPACE_INVITE_TEAMS_APP: 'jira-space-invite-teams-app';
	readonly ROVO_HOME_INPUT_INTENT_EXP: 'rovo_home_input_intent_exp';
	readonly ROVO_TOWNSQ_EMPTY_STATE_GET_PROJECT_DETAILS_SKILL: 'rovo_townsq_empty_state_get_project_details_skill';
	readonly NAVX_UC_ML_POWERED_RELEVANCY_ENGINE: 'navx_uc_ml_powered_relevancy_engine';
	readonly ROVO_GROWTH_CHAT_PULSE_EXPERIMENT: 'rovo_growth_chat_pulse';
	readonly HOME_ONBOARDING_TO_ROVO_CHAT_AND_SEARCH: 'home_onboarding_to_rovo_chat_and_search';
	readonly DISCOVER_PREVIEW_PANELS_EXPERIMENT: 'townsquare_enable_discover_preview_panels_exp';
	readonly TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP: 'townsquare_enable_rovo_home_appification_exp';
	readonly HOME_CALENDAR_WIDGET_EXPERIMENT: 'home_calendar_widget';
	readonly TOWNSQUARE_ASSIGNED_PR_CHAT_INTEGRATION_EXP: 'townsquare_assigned_pr_chat_integration';
	readonly ROVO_CONVERSATION_SHARING_EXP: 'rovo_conversation_sharing';
	readonly ROVO_CHAT_SPACES_EXPERIMENT: 'rovo_chat_spaces_experiment';
	readonly ROVO_CHAT_MENTION_AGENTS_EXPERIMENT: 'rovo_chat_mention_agents';
	readonly TOWNSQUARE_ASSIGNED_LIST_EXP: 'townsquare_assigned_list';
	readonly TOWNSQUARE_VIEWED_DEFAULT_TAB: 'townsquare_exp_viewed_as_default';
	readonly PLATFORM_USE_UNICODE_EMOJIS: 'platform_use_unicode_emojis';
	readonly PLATFORM_TEAMOJI_26_REFRESH_EMOJI_PICKER: 'platform_teamoji_26_refresh_emoji_picker';
	readonly ATLAS_GOAL_TYPES_M3_BUNDLED_UPDATES: 'atlas_goal_types_m3_bundled_updates';
	readonly USER_PROFILE_CARD_MIGRATION_EXP: 'pt_user_profile_card_migration_exp';
} = {
	ROUTER_TEST_EXPERIMENT,
	PROJECTS_NATIVE_INTEGRATION_WITH_JIRA,
	VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT,
	TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT,
	JIRA_SPACE_INVITE_TEAMS_APP,
	ROVO_HOME_INPUT_INTENT_EXP,
	ROVO_TOWNSQ_EMPTY_STATE_GET_PROJECT_DETAILS_SKILL,
	NAVX_UC_ML_POWERED_RELEVANCY_ENGINE,
	ROVO_GROWTH_CHAT_PULSE_EXPERIMENT,
	HOME_ONBOARDING_TO_ROVO_CHAT_AND_SEARCH,
	DISCOVER_PREVIEW_PANELS_EXPERIMENT,
	TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP,
	HOME_CALENDAR_WIDGET_EXPERIMENT,
	TOWNSQUARE_ASSIGNED_PR_CHAT_INTEGRATION_EXP,
	ROVO_CONVERSATION_SHARING_EXP,
	ROVO_CHAT_SPACES_EXPERIMENT,
	ROVO_CHAT_MENTION_AGENTS_EXPERIMENT,
	TOWNSQUARE_ASSIGNED_LIST_EXP,
	PLATFORM_USE_UNICODE_EMOJIS,
	PLATFORM_TEAMOJI_26_REFRESH_EMOJI_PICKER,
	TOWNSQUARE_VIEWED_DEFAULT_TAB,
	ATLAS_GOAL_TYPES_M3_BUNDLED_UPDATES,
	USER_PROFILE_CARD_MIGRATION_EXP,
} as const;

export type ExperimentKeys = keyof typeof experiments;
export type ExperimentNames = (typeof experiments)[ExperimentKeys];
